<div>

  <!-- Payment method selection -->
  <nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <button id="tab-wallet" class="nav-link" type="button" role="tab" data-bs-toggle="tab"
              data-bs-target="#tab-content-wallet"
              aria-controls="tab-content-wallet"
              (click)="selectPaymentType(PaymentMethod.WALLET)"
              [attr.aria-selected]="paymentMethod == PaymentMethod.WALLET"
              [ngClass]="{'active': paymentMethod == PaymentMethod.WALLET}"
              *ngIf="wallets.length > 0">
        <picture>
          <source srcset="/images/payment-form/wallet.webp" type="image/webp">
          <img src="/images/payment-form/wallet.png" alt="Wallet icon" height="20px"/>
        </picture>
      </button>
      <button id="tab-credit-card" class="nav-link" type="button" role="tab" data-bs-toggle="tab"
              data-bs-target="#tab-content-credit-card"
              aria-controls="tab-credit-card"
              (click)="selectPaymentType(PaymentMethod.CREDIT_CARD)"
              [attr.aria-selected]="paymentMethod == PaymentMethod.CREDIT_CARD"
              [ngClass]="{'active': paymentMethod == PaymentMethod.CREDIT_CARD}">
        <picture>
          <source srcset="/images/payment-form/cards.webp" type="image/webp">
          <img src="/images/payment-form/cards.png" alt="Credit cards" height="20px"/>
        </picture>
      </button>
      <button id="tab-paypal" class="nav-link" type="button" role="tab"
              data-bs-toggle="tab"
              data-bs-target="#tab-content-paypal"
              aria-controls="tab-content-paypal"
              (click)="selectPaymentType(PaymentMethod.PAYPAL)"
              [attr.aria-selected]="paymentMethod ===PaymentMethod.PAYPAL"
              [ngClass]="{'active': paymentMethod == PaymentMethod.PAYPAL}">
        <picture>
          <source srcset="/images/payment-form/paypal.webp" type="image/webp">
          <img src="/images/payment-form/paypal.png" alt="PayPal logo" height="20px"/>
        </picture>
      </button>
    </div>
  </nav>

  <!-- Payment methods -->
  <div id="nav-tabContent" class="tab-content">
    <br/>

    <!-- Wallet -->
    <div id="tab-content-wallet" class="tab-pane fade" role="tabpanel" aria-labelledby="tab-wallet"
         [ngClass]="{'show active': paymentMethod == PaymentMethod.WALLET}">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="wallet-content">
              <label *ngFor="let wallet of wallets">
                <div class="radio-item">
                  <input type="radio" name="wallet" [value]="wallet._id" (change)="selectWallet(wallet)" [checked]="walletSelected && walletSelected._id === wallet._id"/>
                  <span *ngIf="wallet.type === 'stripe_customer'">
                    <span class="me-2"><i class="bi bi-credit-card"></i></span>
                    <span class="me-2">{{ wallet.reference.sources.data[0].brand }}</span>
                    <br class="hide-md hide-lg hide-xl hide-xxl"/>
                    <span class="me-2">**** **** **** {{ wallet.reference.sources.data[0].last4 }}</span>
                  </span>
                  <span *ngIf="wallet.type === 'braintree_customer'">
                    <span class="me-2"><i class="bi bi-paypal"></i></span>
                    <span class="me-2">PayPal</span>
                    <br class="hide-md hide-lg hide-xl hide-xxl"/>
                    <span class="me-2">({{ wallet.reference.paypalAccounts[0].email }})</span>
                  </span>
                  <span *ngIf="wallet.type === 'invoice_customer'">
                    <span class="me-2"><i class="bi bi-bank"></i></span>
                    <span class="me-2">Invoice</span>
                    <br class="hide-md hide-lg hide-xl hide-xxl"/>
                    <span class="me-2">&nbsp;</span>
                  </span>
                </div>
              </label>
            </div>

            <br/>

            <div class="alert alert-warning" *ngIf="isWalletSelectedPreviousFailed">
              <small>Your payment method recently failed. To retry payment click <strong>{{ paypalInstructions }}</strong>.</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Credit card -->
    <div id="tab-content-credit-card" class="tab-pane fade" role="tabpanel" aria-labelledby="tab-credit-card"
         [ngClass]="{'show active': paymentMethod == PaymentMethod.CREDIT_CARD}">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <label for="credit-card-number">Card number</label>
            <div class="input-group">
              <input id="credit-card-number" type="text" name="creditCardNumber" [(ngModel)]="creditCardNumber" (change)="validate()" class="form-control" creditCardNumber>
            </div>
            <br/>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <label for="credit-card-expiration">Exp. Date</label>
                <div class="input-group">
                  <input id="credit-card-expiration" type="text" name="creditCardExpiration" [(ngModel)]="creditCardExpiration" (change)="validate()" class="form-control" placeholder="MM/YY" creditCardExpiration>
                </div>
                <br/>
              </div>
              <div class="col-6">
                <label for="credit-card-ccv">CCV</label>
                <div class="input-group">
                  <input id="credit-card-ccv" type="password" name="creditCardCCV" [(ngModel)]="creditCardCCV" (change)="validate()" class="form-control" placeholder="CCV" creditCardCCV>
                </div>
                <br/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Paypal -->
    <div id="tab-content-paypal" class="tab-pane fade" role="tabpanel" aria-labelledby="tab-paypal"
         [ngClass]="{'show active': paymentMethod == PaymentMethod.PAYPAL}">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="text-center">
              <p class="little-text">1) Log in to PayPal using this button:</p>
              <div class="text-center" style="min-height: 44px;">
                <span *ngIf="isPaypalLoading" class="spinner-border spinner-border ms-2"></span>
                <div #paypalButton id="paypal-button"></div>
              </div>
              <br/>
              <p class="little-text">2) Click "{{ paypalInstructions }}" below. <br/>&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
  </div>

</div>
